var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-device"},[_c('s-swiper',{attrs:{"title":{
      text: '关联硬件',
      color: '设备',
    },"dataList":_vm.list,"fit":"contain"},on:{"change":_vm.swiperChange},scopedSlots:_vm._u([{key:"desc",fn:function(){return [_vm._v(" "+_vm._s(_vm.desc)+" ")]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }